//import mylocal from "./data/data.json";
let mylocal = [];
let header = [];
let result = [];
let data = [];
let month = [];
month[0] = "Enero";
month[1] = "Febrero";
month[2] = "Marzo";
month[3] = "Abril";
month[4] = "Mayo";
month[5] = "Junio";
month[6] = "Julio";
month[7] = "Agosto";
month[8] = "Septiembre";
month[9] = "Octubre";
month[10] = "Noviembre";
month[11] = "Diciembre";

let last_month_num=0;
let dataServer = (props) => {
  result = [];
  let mdx = [];
  data = [];
  header = [];
  fetch("https://app.sotechcloud.com/sinia/senace-data.json")
    .then(res => res.json())
    .then(
      (response) => {
        mylocal = response;
        mylocal.result.fArray.map(function (item, j) {
          if (item.fHeader) {
            header[j] = item;
          }
          if (!item.fHeader) {
            data[j] = item;
          }
        });
        if (data.length > header.length) {
          var count_header = header.length;
          var has = true;
          var increment = header.length;
          var item = [];
          while (has) {
            for (var k = increment; k < increment + count_header; k++) {
              item.push({ value: data[k].fStr });
            }
            result.push(item);
            item = [];
            increment = increment + count_header;
            if (!data[increment]) {
              has = false;
            }
          }
          let last_period={};
          for (var i = 0, max = result.length; i < max; i++) {
            var dateParts = result[i][5].value.split("/");
            let _month=new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]).getMonth();
            let _year=new Date(+dateParts[2],dateParts[1] - 1,+dateParts[0]).getFullYear();
            if(_month>last_month_num){
              last_month_num=_month;
              last_period[_year]=month[_month];
            }
            var child = {
              codigo: result[i][0].value,
              medio_recepcion: result[i][1].value,
              departamento: result[i][2].value,
              provincia: result[i][3].value,
              distrito: result[i][4].value,
              fecha_registro: result[i][5].value,
              anio: new Date(
                +dateParts[2],
                dateParts[1] - 1,
                +dateParts[0]
              ).getFullYear(),
              mes: month[_month],
              sector: result[i][6].value,
              es_agua: parseInt(result[i][7].value),
              es_aire: parseInt(result[i][8].value),
              es_suelo: parseInt(result[i][9].value),

              es_vert_liquido: parseInt(result[i][13].value),
              es_vert_solido: parseInt(result[i][14].value),
              es_gas: parseInt(result[i][15].value),
              es_particulado: parseInt(result[i][16].value),
              es_radiacion: parseInt(result[i][18].value),
              es_visual: parseInt(result[i][19].value),
              es_sonora: parseInt(result[i][20].value),
              modo_presentado: result[i][21].value,
              estado: result[i][22].value
            };
            mdx.push(child);
          }
          mdx.last=last_period;
        }
        props(mdx);
      },
      (error) => {
        console.log(error);
      }
    );
  return [];
};

export default dataServer;
